<template>
  <div class="video-preview-expand" id="video-preview-expand" :style="ownStyle">
    <div class="video-preview-expand-container">
      <div class="video-preview-expand-container-top" :style="videoContainerHasToolbarStyle">
        <div :style="videoContainerStyle">
          <!-- 此处无法使用code模式 需要兼容回放处理 -->
          <video-preview
            ref="videoPreview"
            :mode="videoMode"
            :src="videoSrc"
            :hkCode="hkVideoCode"
            :hkConfig="hkConfig"
            :videojsOption="videojsOption"
            :vlcOptions="vlcOptions"
            :jessibucaOptions="jessibucaOptions"
            :whOptions="whOptions"
            :dhIccOptions="dhIccOptions"
            :DHvideoType="DHvideoType"
            :univiewCode="ysCode"
            :proxyHost="proxyHost"
            :timeout="timeout"
            @createSuccess="createSuccess"
            @recordBlob="recordBlob"
          ></video-preview>
        </div>
        			<div class="media-play-urls media-play-block" v-if="checkUrl">
				<el-scrollbar class="iot-scrollbar hidden-x" style="height: 120px;overflow-x: hidden;">
					<ul class="media-play-urls-list">
						<li :class="['media-play-urls-list-item', currentUrl && currentUrl.url === item.url ? 'highlight' : '']" v-for="(item, index) in urls" :key="`mpurlIndex${index}`" @click="handleSrcChange(item)">
							<div class="mpuli-left">
								<em class="mpuli-type">{{item.type}}</em>
								<el-tooltip placement="top" :content="item.url">
									<span class="mpuli-url">{{item.url}}</span>
								</el-tooltip>
							</div>
							<el-button class="iot-button p-0" type="text" v-clipboard:copy="item.url" v-clipboard:success="onCopySuccess">复制</el-button>
						</li>
					</ul>
				</el-scrollbar>
			</div>
        <!-- 对讲 -->
        <div v-if="voiceFlag" class="video-preview-expand-container-voice ml10">
          <el-button size="mini" class="vp-button mb10" @click="startVoice">开启对讲</el-button>
          <el-button size="mini" class="vp-button mb10" @click="stopVoice">停止对讲</el-button>
          <el-button size="mini" class="vp-button mb10" @click="openSound">开启音频</el-button>
          <el-button size="mini" class="vp-button" @click="closeSound">关闭音频</el-button>
        </div>
        <!-- 录像 -->
        <div v-if="recordFlag" class="video-preview-expand-container-voice ml10">
          <el-button size="mini" class="vp-button mb10" @click="startRecord">开始录像</el-button>
          <el-button size="mini" class="vp-button mb10" @click="stopRecord">停止录像</el-button>
        </div>
        <!-- 云台 -->
        <div v-else-if="ptzUIFlag" class="video-preview-expand-container-ptz ml10">
          <h5 class="title">云台控制</h5>
          <div class="vptb-left">
            <div class="vptb-block vptc-direction">
              <div class="vptc-direction-container">
                <div class="vptc-direction-container-item" v-for="(item, index) in PTZ_CONFIG" :key="`PTZ_CONFIG${index}`">
                  <img
                    v-if="item.need"
                    @mouseup="cancelPtzCommand(item.command, 'stop')"
                    @mousedown="startPtzCommand(item.command)"
                    :style="item.style"
                    :src="arrow"
                  />
                  <img v-else :src="reset" @click="startPtzCommand(item.command)" />
                </div>
              </div>
            </div>
            <div class="vptb-block vptc-focal">
              <div class="increase-or-decrease">
                <img
                  class="increase-or-decrease-item"
                  :src="focus_add"
                  title="焦点变进"
                  srcset=""
                  @mouseup="cancelPtzCommand('ZOOM_IN', 'stop')"
                  @mousedown="startPtzCommand('ZOOM_IN')"
                />
                <img
                  class="increase-or-decrease-item"
                  :src="focus_dec"
                  title="焦点变远"
                  srcset=""
                  @mouseup="cancelPtzCommand('ZOOM_OUT', 'stop')"
                  @mousedown="startPtzCommand('ZOOM_OUT')"
                />
              </div>
              <div class="increase-or-decrease">
                <img
                  class="increase-or-decrease-item"
                  :src="focallen_add"
                  title="焦距增大"
                  srcset=""
                  @mouseup="cancelPtzCommand('FOCUS_NEAR','stop')"
                  @mousedown="startPtzCommand('FOCUS_NEAR')"
                />
                <img
                  class="increase-or-decrease-item"
                  :src="focallen_dec"
                  title="焦距缩小"
                  srcset=""
                  @mouseup="cancelPtzCommand('FOCUS_FAR', 'stop')"
                  @mousedown="startPtzCommand('FOCUS_FAR')"
                />
              </div>
              <div class="increase-or-decrease">
                <img
                  class="increase-or-decrease-item"
                  :src="aperture_add"
                  title="光圈增大"
                  srcset=""
                  @mouseup="cancelPtzCommand('IRIS_ENLARGE', 'stop')"
                  @mousedown="startPtzCommand('IRIS_ENLARGE')"
                />
                <img
                  class="increase-or-decrease-item"
                  :src="aperture_dec"
                  title="光圈缩小"
                  srcset=""
                  @mouseup="cancelPtzCommand('IRIS_REDUCE', 'stop')"
                  @mousedown="startPtzCommand('IRIS_REDUCE')"
                />
              </div>
            </div>
          </div>
          <div class="vptb-right vptb-block vptc-reset">
            <!-- 速度 -->
            <input class="range-input" type="range" name="points" v-model="ptzOption.speed" min="10" max="100">
                        <span class="speed-value">{{ptzOption.speed}}</span>
          </div>
        </div>
        <!-- 回放 -->
        <div v-else-if="videoBackFlag" class="video-preview-expand-container-videoback ml10">
          <h5 class="title">视频回放</h5>
          <el-date-picker
            popper-class="vp-date-popper"
            size="small"
            class="mb10 vp-block"
            v-model="videoBackForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
          <!-- myeyes不显示 -->
          <el-time-picker
            v-if="
              iotVideoObj &&
              iotVideoObj.source !== SOURCE_ENUM.myeyes &&
              iotVideoObj.source !== SOURCE_ENUM.dahuaicc &&
              iotVideoObj.source !== SOURCE_ENUM.dahua8900 &&
              iotVideoObj.source !== SOURCE_ENUM.icvs &&
              iotVideoObj.source !== SOURCE_ENUM.minking
            "
            popper-class="vp-date-popper"
            size="small"
            class="mb10 vp-block"
            is-range
            value-format="HH:mm:ss"
            v-model="videoBackForm.videoTime"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker>
          <el-radio-group class="mb10 vp-block" v-model="videoBackForm.recordLocation">
            <el-radio :label="0">服务器存储</el-radio>
            <el-radio :label="1">设备存储</el-radio>
          </el-radio-group>
          <div>
            <el-button size="mini" class="vp-button" @click="queryVideoRecord">查询/播放录像</el-button>
            <el-button size="mini" class="vp-button" @click="startPreview">返回预览</el-button>
          </div>
          <el-table
            v-if="recordList.length > 0"
            size="mini"
            class="vp-table"
            header-row-class-name="vp-table-header"
            :height="tableHeight"
            style="width: 100%"
            :data="recordList"
          >
            <el-table-column label="时间">
              <template slot-scope="scope">
                <span style="color: #606266">{{ splitDay(scope.row.recordTimeStart) }}-{{ splitDay(scope.row.recordTimeEnd) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预览" width="50">
              <template slot-scope="scope">
                <img width="16px" :src="videoback" @click="handleSelectionChange(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 底部Toolbar -->
      <div v-if="uiOptions.toolbar" class="video-preview-expand-toolbar">
        <div class="tbl">
          <!-- <span>{{ iotVideoObj && iotVideoObj.name }}</span> -->
        </div>
        <div class="tbc">
          <span>{{ extraInfo }}</span>
        </div>
        <div class="tbr">
          <!-- <el-button ref="autoPlayBtn" v-if="videoMode === 16" size="mini" id="autoPlayBtn" class="vp-button" @click="DHiccPlay">回看</el-button> -->
          <!-- <el-button ref="closeBtn" v-if="videoMode === 16" size="mini" class="vp-button" @click="DHiccClose">大华关闭</el-button> -->
          <el-button v-if="uiOptions.toolbar.voiceButton" size="mini" class="vp-button" @click="openVoice">对讲</el-button>
          <el-button v-if="uiOptions.toolbar.recordButton" size="mini" class="vp-button" @click="openRecord">录制</el-button>
          <el-button v-if="uiOptions.toolbar.backButton" size="mini" class="vp-button" @click="openVideoBack">回放</el-button>
          <el-button v-if="uiOptions.toolbar.ptzButton" size="mini" class="vp-button" @click="openPtzControl">云台</el-button>
          <el-button v-if="uiOptions.toolbar.screenButton" size="mini" class="vp-button" @click="takeScreenShot">截图</el-button>
        </div>
      </div>
    </div>
    <slot name="video-slot"> </slot>
  </div>
</template>

<script>
// ****************IOT业务功能扩展组件******************
// import axios from 'axios'
import axios from './axios'
import videoPreview from './videoPreview.vue'
import { downloadBase64Data, isHttps, isOnvif } from './../utils'
import {
  supportSpecialFlagUrl,
  supportRepackingUrl,
  supportHikvisonRepackingUrl,
  supportNYUrl,
  supportIVMSUrl,
  supportAYUrl,
  supportNewPreviewUrl
} from './getVideoUrl'
import {
  IOT_SPECIAL_FLAG,
  MJMapCommand,
  PTZ_CONFIG,
  SOURCE_ENUM,
  SUPPORT_PTZS,
  URLS,
  USE_GETGPS_VIDEO_SOURCE,
  USE_NEW_PREVIEW_VIDEO_SOURCE,
  VIDEO_MODE_ENUM,
  VIDEO_PROTOCOL
} from './../config'
import arrow from './../assets/arrow.png'
import focallen_add from './../assets/focallen_add.png'
import focallen_dec from './../assets/focallen_dec.png'
import focus_add from './../assets/focus_add.png'
import focus_dec from './../assets/focus_dec.png'
import aperture_add from './../assets/aperture_add.png'
import aperture_dec from './../assets/aperture_dec.png'
import reset from './../assets/reset.png'
import videoback from './../assets/videoback.png'
import pick from 'lodash/pick'
import merge from 'lodash/merge'
import { splitDay } from '../utils'
import { VDate } from '../utils/date'
import { newGUID } from '../utils/guid'

export default {
  name: 'video-preview-expand',
  components: { videoPreview },
  props: {
    code: String, // 公司内部网络使用
    src: String,
    mode: String,
    ownStyle: {
      type: String,
      default: ''
    },
    uiOptions: {
      type: Object,
      default: () => {
        return {
          toolbar: false
        }
      }
    },
    videojsOption: Object,
    vlcOptions: Object,
    jessibucaOptions: Object,
    whOptions: Object,
    dhIccOptions: Object,
    proxyFunction: Object, // 外部代理方法回调
    proxyHost: {
      type: String,
      default: ''
    },
    crossContainer: {
      type: Boolean,
      default: false
    },
    checkUrl:{    //切换播放地址
      type:Boolean,
      default: false
    },
    timeout:{   
      type:Boolean,
      default: false
    },
    voiceState:{   
      type:Boolean,
      default: false
    },
  },
  data() {
    return {
      arrow,
      focallen_add,
      focallen_dec,
      focus_add,
      focus_dec,
      aperture_add,
      aperture_dec,
      PTZ_CONFIG,
      reset,
      videoback,
      splitDay,
      SOURCE_ENUM,
      ptzOption: {
        step: 1,
        speed: 40
      },
      ysCode: '',
      previewMode: '',
      iframeSrc: '',
      timer: null,
      videoSrc: null,
      hkVideoCode: null,
      activeComponent: null,
      videoMode: null,
      iotVideoObj: null,
      ptzUIFlag: false,
      voiceFlag: false,
      videoBackFlag: false,
      recordFlag: false,
      startRecordFlag: false,
      dhVideoCode: null,
      videoBackForm: {
        date: '',
        videoTime: ['', ''],
        recordLocation: 0
      },
      recordList: [],
      hkConfig: {
        playMode: 0,
        showToolBar:1,
      },
      extraInfo: '',
      isPlaybackFlag: false,
      urlsData:[],
      DHvideoType:'video1'
    }
  },
  computed: {
    // video container 宽高
    videoContainerHasToolbarStyle() {
      // 如果需要toolbar且存在code
      if (this.uiOptions.toolbar) {
        return {
          width: '100%',
          height: 'calc(100% - 40px)'
        }
      }
      return {
        height: '100%',
        width: '100%'
      }
    },
    // container 宽高
    videoContainerStyle() {
      // 如果需要toolbar且存在code
      if (this.uiOptions.toolbar && this.ptzUIFlag) {
        return {
          height: '100%',
          width: '100%'
        }
      }
      return {
        width: '100%',
        height: '100%'
      }
    },
    toolbarStyle() {
      // 如果打开云台
      if (this.ptzUIFlag) {
        return {
          width: '160px'
        }
      }
      return {
        width: '0px'
      }
    },
    tableHeight() {
      // 如果打开云台
      if (this.iotVideoObj && this.iotVideoObj.source === SOURCE_ENUM.myeyes) {
        return 'calc(100% - 140px)' 
      }
      return 'calc(100% - 160px)'
    }
  },
  mounted() {
    this.start()
  },
  watch: {
    code(v) {
      this.start()
    },
    src(v) {
      this.start()
    }
  },
  methods: {
    async start(callback) {
      const { code } = this
      // console.warn(135,code,this)
      // 如果当前组件包含code 走公司内部播放流程
      if (code) {
        // console.error(111,code);
        // 跨容器查询
        if (this.crossContainer) {
          let params = {
            params: {
              code
            }
          }
          let res = await axios.get(this.proxyHost + URLS.getVideoByCodeUrl, params)
          if (res && res.status === 200 && res.data.result) {
            this.iotVideoObj = res.data.result
            this.hkVideoCode = res.data.result.code
            this.dhVideoCode = res.data.result.code
            this.ysCode = res.data.result.code
            this.hkConfig.transType = (this.iotVideoObj.transType === undefined || this.iotVideoObj.transType === null) ? 1 : this.iotVideoObj.transType;
            this.startInit()
          }
          return
        }
        // 普通查询
        let params = {
          params: {
            categoryName: '',
            categoryId: '',
            search: '',
            code,
            codeSign: 'equal',
            pageSize: 150,
            pageNum: 1
          }
        }
        let res = await axios.get(this.proxyHost + URLS.getVideoUrl, params)
        if (res && res.status === 200 && res.data.result.list.length > 0) {
          this.iotVideoObj = res.data.result.list[0]
          this.hkVideoCode = res.data.result.list[0].code
          this.dhVideoCode = res.data.result.list[0].code
          this.ysCode = res.data.result.list[0].code
          this.hkConfig.transType = (this.iotVideoObj.transType === undefined || this.iotVideoObj.transType === null) ? 1 : this.iotVideoObj.transType;
          // console.log(222);
          this.startInit()
        }
      } else if (this.src) {
        this.setVideoVal(this.src, this.mode, 0, 0)
        setTimeout(() => {
          this.$refs.videoPreview.init()
        }, 1000)
      } else {
        console.error('请传入视频URL使用！|| 请传入物联网视频编码使用！')
      }
    },
    init() {
      console.log('init',this.src, this.mode);
      this.$refs.videoPreview.init()
    },
    // 初始化分装
    async startInit() {
      // console.log(333);
      let mode = this.iotVideoObj.mode
      let url = this.iotVideoObj.stream
      const source = this.iotVideoObj.source
      const transType = this.hkConfig.transType
      // 优先级最高 兼容特殊URL对接安元平台
      if (url && url.indexOf(IOT_SPECIAL_FLAG) > -1) {
        let specialRes = await supportSpecialFlagUrl(this.proxyHost, this.iotVideoObj,urls).catch((e) => {
          console.error(e)
          return e
        })
        mode = specialRes.mode ? specialRes.mode : mode
        url = specialRes.url ? specialRes.url : url
        this.urlsData = specialRes.url ? specialRes.url : url
      }
      // 提供自定义流转码播放
      if (!source && this.iotVideoObj.isProxyStream) {
        let repackRes = await supportRepackingUrl(this.proxyHost, this.iotVideoObj.stream, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        console.log(123,url,'转码：',repackRes.url );
        mode = repackRes.mode ? repackRes.mode : mode
        url = repackRes.url ? repackRes.url : url
      }
      // 提供海康转流播放配置 支持外部配置传入 以及视频流配置
      // if (source && source === SOURCE_ENUM.hikvision && (this.hkConfig && this.hkConfig.protocol)) { //废弃
      //   let hikRes = await supportHikvisonRepackingUrl(this.proxyHost, this.iotVideoObj, this.hkConfig).catch((e) => {
      //     console.error(e)
      //     return e
      //   })
      //   mode = hikRes.mode ? hikRes.mode : mode
      //   url = hikRes.url ? hikRes.url : url
      // }
      // 南耀特殊播放
      if (mode == 'NY') {
        let nyRes = await supportNYUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = nyRes.mode ? nyRes.mode : mode
        url = nyRes.url ? nyRes.url : url
        this.playNYToken = nyRes.token
        this._startNyKeepAlive(nyRes.token)
      }
      // iVMS海康平台播放
      if (mode == VIDEO_MODE_ENUM.iVMSHK) {
        let ivmsRes = await supportIVMSUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = ivmsRes.mode ? nyRes.mode : mode
        url = ivmsRes.url ? nyRes.url : url
      }
      // 安元平台播放取流
      if (this.iotVideoObj.source == SOURCE_ENUM.ay) {
        let ayRes = await supportAYUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = ayRes.mode ? ayRes.mode : mode
        url = ayRes.url ? ayRes.url : url
      }
      //- 海康转流 --平台统一接入
      if(source && ['hikvision'].includes(source) && (mode==='0' && this.iotVideoObj.isProxyStream)){
          const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
          let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'RTSP',proxyType, transType).catch((e) => {
          this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
          return e
        })
        mode = hkHls.mode ? hkHls.mode : mode
        url = hkHls.url ? hkHls.url : url
        return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.ysCode);
      }
      //- 海康取h5流
      if(source && ['hikvision'].includes(source) && (mode==='0' && !this.iotVideoObj.isProxyStream)){
          const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
          let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'hls',proxyType, transType).catch((e) => {
          this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
          return e
        })
        mode = hkHls.mode ? hkHls.mode : mode
        url = hkHls.url ? hkHls.url : url
        return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.ysCode);
      }
        //- 大华转流取流 --平台统一接入
       if(source && ['dahuaicc','dahua8900'].includes(source) && (mode==='0' || this.iotVideoObj.isProxyStream)){
           const proxyType =  'https:'==location.protocol ? 'wss': 'ws';
           let hkHls = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj, 'hls',proxyType).catch((e) => {
           this._showErrorMsg(VP_ERROR.HK_HLS_FAIL)
           return e
         })
         mode = hkHls.mode ? hkHls.mode : mode
         url = hkHls.url ? hkHls.url : url
         return this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.ysCode);
       }

      // 支持新的取流接口平台 暂时使用新的获取流地址接口
      if (this.iotVideoObj.source && USE_NEW_PREVIEW_VIDEO_SOURCE.indexOf(this.iotVideoObj.source) > -1) {
        let previewRes = await supportNewPreviewUrl(this.proxyHost, this.iotVideoObj).catch((e) => {
          console.error(e)
          return e
        })
        mode = previewRes.mode ? previewRes.mode : mode
        url = previewRes.url ? previewRes.url : url
      }

      this.setVideoVal(url, mode, this.hkVideoCode, this.dhVideoCode, this.ysCode)
      setTimeout(() => {
        this.$refs.videoPreview.init()
      }, 1000)
    },

    // 除海康需视同code外其余的均为url
    setVideoVal(src, mode, hkCode, dhCode, univiewCode) {
      if (typeof mode === 'string') {
        this.videoMode = Number(mode)
      } else {
        this.videoMode = mode
      }
      this.$nextTick(() => {
        if (this.videoMode == 0) {
          this.videoSrc = src
        } else if (this.videoMode == 1) {
          this.videoSrc = src
        } else if (this.videoMode == 2) {
          this.videoSrc = src
        } else if (this.videoMode == 3) {
          this.hkVideoCode = hkCode
        } else if (this.videoMode == 8) {
          this.dhVideoCode = dhCode
        } else if (this.videoMode == 7) {
          this.mjConfigStr = src
        } else if (this.videoMode == 11) {
          this.videoSrc = src
        } else if (this.videoMode == 13) {
          this.videoSrc = src
        } else if (this.videoMode == 14) {
          this.videoSrc = src
        } else if (this.videoMode == 15) {
          this.ysCode = univiewCode
        } else if (this.videoMode == 16) {
          this.videoSrc = src
        }
      })
    },
    playBtnClick(){
      this.$refs.videoPreview?.playBtnClick()
    },
    // 布控球相关 可获取GPS信息并展示
    getGPSInfo(code) {
      const url = this.proxyHost + URLS.getGPSUrl
      axios
        .get(url, { params: { code } })
        .then((res) => {
          if (this.iotVideoObj.source == SOURCE_ENUM.icvs) {
            this.extraInfo = `纬度：${res.data.result.GPS.Latitude}, 经度：${res.data.result.GPS.Longitude}`
          } else if (this.iotVideoObj.source == SOURCE_ENUM.minking) {
            this.extraInfo = `纬度：${res.data.result.latitude}, 经度：${res.data.result.longitude}`
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openVideoBack() {
      this.recordFlag = false
      this.voiceFlag = false
      this.ptzUIFlag = false
      this.videoBackFlag = !this.videoBackFlag
      if (this.videoMode == 3) {
        this.$refs.videoPreview.getActiveComponent().resizePlayWindows()
      }
    },
    openPtzControl() {
      this.recordFlag = false
      this.voiceFlag = false
      this.videoBackFlag = false
      this.ptzUIFlag = !this.ptzUIFlag
      if (this.videoMode == 3) {
        this.$refs.videoPreview.getActiveComponent().resizePlayWindows()
      }
    },
    openVoice() {
      this.recordFlag = false
      this.ptzUIFlag = false
      this.videoBackFlag = false
      this.voiceFlag = !this.voiceFlag
    },
    openRecord() {
      this.ptzUIFlag = false
      this.videoBackFlag = false
      this.voiceFlag = false
      this.recordFlag = !this.recordFlag
    },
    // 开始录像
    startRecord() {
      const url = this.proxyHost + URLS.startRecordUrl
      axios
        .get(url, {
          params: {
            code: this.iotVideoObj.code
          }
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.startRecordFlag = true
          }
        })
    },
    // 停止录像
    stopRecord() {
      const url = this.proxyHost + URLS.stopRecordUrl
      axios
        .get(url, {
          params: {
            code: this.iotVideoObj.code
          }
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
          }
        })
    },
    startVoice(){
          this.$parent.changeJessi? this.$parent.changeJessi() : this.$emit('changeJessi');
          this.$nextTick(()=>{
            this.startVoice1()
          })
    },
    startVoice1() {
      // 语音对讲
      if (this.videoMode == 2 || this.videoMode == 11 || this.videoMode == 0) {
        if (this.vlcOptions.webSrc) {
          // demo自测用
          this.$refs.videoPreview.startVoice(this.vlcOptions.webSrc)
        } 
        else {
          if (!this.vlcOptions.channerId) {
            return console.error('缺少通道Id！')
          }
          console.warn('通道Id:',this.vlcOptions.channerId);
          const url1 = this.proxyHost + URLS.getStartVoice + '?id=' + this.vlcOptions.channerId
          axios.get(url1,{withCredentials:true}).then((res) => {
            if (res.status == 200) {
              if (res.data.result.result) {
                if(!res.data.result.enabled) return console.error('不支持语音');
                // this.$refs.videoPreview.cancelMute()
                this.$refs.videoPreview.startVoice(res.data.result.audio)
              }
            }
          })
        }
        return
      }
      if (!this.iotVideoObj) {
        return
      }
      if (this.iotVideoObj.source !== SOURCE_ENUM.minking) {
        console.error('明景布控球特供方法！')
        return
      }
      const url = this.proxyHost + URLS.voiceUrl

      axios
        .post(url, {
          code: this.iotVideoObj.code
        })
        .then((res) => {
          if (res.status == 200 && res.data.code == 200) {
            this.$refs.videoPreview.startVoice(res.data.result)
          }
        })
    },
    stopVoice() {
      const url = this.proxyHost + URLS.getStopVoice + '?id=' + this.vlcOptions.channerId
      axios.get(url).then((res) => {
        // console.log('stop', res)
        if (res.data.status == 200 && res.data.result) {
          this.$refs.videoPreview.stopVoice()
          this.$parent.changeVideojs? this.$parent.changeVideojs() : this.$emit('changeVideojs')
          // 切换h5
        }
      })
    }, 
    openSound() {
      this.$refs.videoPreview.openSound()
    },
    closeSound() {
      this.$refs.videoPreview.closeSound()
    },
    // 直接截图并下载
    takeScreenShot() {
      const base64Data = this.$refs.videoPreview.screenShot()
      if (base64Data) {
        downloadBase64Data(base64Data)
      }
    },
    // 返回预览视频
    async startPreview() {
      if (this.isPlaybackFlag) {
        // 海康播放器的情况下 销毁重新初始化
        if (this.videoMode == VIDEO_MODE_ENUM.hkPlayer) {
          let res = await this.$refs.videoPreview.dispose()
          this.hkConfig.playMode = 0
          this.hkVideoCode = this.iotVideoObj.code
          this.$nextTick(() => {
            this.$refs.videoPreview.init()
          })
        } else {
          // 其他的直接换流
          this.videoSrc = this.iotVideoObj.stream
        }
      }
    },
    // 查询录像
    async queryVideoRecord() {
      // 如果外部代理云台方法存在
      if (this.proxyFunction && this.proxyFunction.queryVideoRecord) {
        let res = await this.proxyFunction.queryVideoRecord(this.videoBackForm.date, this.videoBackForm.recordLocation).catch((e) => {
          return Promise.reject(e)
        })
        if (res.success) {
          this.recordList = res.list
        }
        return
      }

      if (!this.iotVideoObj) {
        console.error('IOT视频对象不存在！请检查！')
        return
      }
      switch (this.iotVideoObj.source) {
        case SOURCE_ENUM.uniview:
        case SOURCE_ENUM.hikvision:
          this.hkVideoRecord()
          break
        case SOURCE_ENUM.myeyes:
          this.myeyesVideoRecord()
          break
        case SOURCE_ENUM.icvs:
          this.commonVideoRecord(SOURCE_ENUM.icvs)
          break
        case SOURCE_ENUM.dahuaicc:
          this.commonVideoRecord(SOURCE_ENUM.dahuaicc)
          break
        case SOURCE_ENUM.dahua8900:
          this.commonVideoRecord(SOURCE_ENUM.dahua8900)
          break
        case SOURCE_ENUM.minking:
          this.commonVideoRecord(SOURCE_ENUM.minking)
          break
        case SOURCE_ENUM.ay:
          this.ayVideoRecord()
          break
        default:
          console.warn('当前视频不支持回放!')
          // this.commonVideoRecord()
          break
      }
    },
    // icvs回放 后续等接口稳定后做成通用回放
    commonVideoRecord(type) {
      if (!this.videoBackForm.date) {
        console.error('请选择时间')
        return
      }
      const url = this.proxyHost + URLS.listRecords
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'

      const params = {
        code: this.code,
        recordFrom: recordFrom,
        date: this.videoBackForm.date
      }
      axios.get(url, { params }).then((res) => {
        this.recordList = res.data.result.map((item) => {
          if (type == SOURCE_ENUM.minking) {
            item.recordTimeStart = VDate.formatTimeStamp(item.begin, 'YYYY-MM-DD hh:ii:ss', true, false)
            item.recordTimeEnd = VDate.formatTimeStamp(item.end, 'YYYY-MM-DD hh:ii:ss', true, false)
            return item
          }
          item.recordTimeStart = VDate.formatTimeStamp(item.Begin)
          item.recordTimeEnd = VDate.formatTimeStamp(item.End)
          return item
        })
      })
    },
    // 海康宇视回放
    async hkVideoRecord() {
      if (!this.videoBackForm.date || !this.videoBackForm.videoTime[0] || !this.videoBackForm.videoTime[1]) {
        console.error('请选择时间')
        return
      }
      // 海康自有播放器 回放
      if (this.videoMode == VIDEO_MODE_ENUM.hkPlayer) {
        // 销毁当前海康实例
        let res = await this.$refs.videoPreview.dispose()
        // 重置成回放模式
        this.hkConfig.playMode = 1

        this.start(() => {
          this.isPlaybackFlag = true
          this.startTime = new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`).getTime()
          this.endTime = new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`).getTime()

          this.$refs.videoPreview.previewBack(this.startTime, this.endTime, this.hkVideoCode, this.videoBackForm.recordLocation)
        })
      } else if (this.mode === VIDEO_MODE_ENUM.uniview) {
        this.startTime = new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`)
        this.endTime = new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`)
        this.$refs.videoPreview.previewBack(this.startTime, this.endTime, this.code, this.videoBackForm.recordLocation)
      }
    },
    // myeyes回放
    myeyesVideoRecord() {
      if (!this.videoBackForm.date) {
        console.error('请选择时间')
        return
      }
      const url = this.proxyHost + URLS.myeyesVideoRecordsList
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'ss' : 'device'
      const params = {
        code: this.code,
        queryDay: this.videoBackForm.date,
        recordFrom
      }
      axios.get(url, { params }).then((res) => {
        if (res && res.status === 200 && res.data.code === 200) {
          this.recordList = res.data.result
        }
      })
    },
    // 安元平台回放
    ayVideoRecord() {
      if (!this.videoBackForm.date || !this.videoBackForm.videoTime[0] || !this.videoBackForm.videoTime[1]) {
        console.error('请选择时间')
        return
      }
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const url = this.proxyHost + URLS.ayVideoRecordUrl
      const params = {
        loc: recordFrom,
        id: this.code,
        start: new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`).getTime(),
        end: new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`).getTime()
      }

      axios.get(url, { params }).then((res) => {
        this.recordList = res.data.result.map((item) => {
          item.recordTimeStart = VDate.formatTimeStamp(item.startTime, 'YYYY-MM-DD hh:ii:ss', true)
          item.recordTimeEnd = VDate.formatTimeStamp(item.endTime, 'YYYY-MM-DD hh:ii:ss', true)
          return item
        })
      })
    },
    async handleSelectionChange(row) {
      // 如果外部代理方法存在
      if (this.proxyFunction && this.proxyFunction.handleSelectionChange) {
        let res = await this.proxyFunction.handleSelectionChange(row).catch((e) => {
          return Promise.reject(e)
        })
        if (res.success) {
          this.videoSrc = res.src
        }
        return
      }
      // myeyes record play
      switch (this.iotVideoObj.source) {
        case SOURCE_ENUM.myeyes:
          this.myeyesRecordPlay(row)
          break
        case SOURCE_ENUM.icvs:
          this.icvsRecordPlay(row)
          break
        case SOURCE_ENUM.dahuaicc:
          this.icvsRecordPlay(row)
          break
        case SOURCE_ENUM.dahua8900:
          this.icvsRecordPlay(row)
          break
        case SOURCE_ENUM.minking:
          this.mjRecordPlay(row)
          break
        case SOURCE_ENUM.ay:
          this.ayRecordPlay(row)
          break
        default:
          break
      }
    },
    // # https://icvs.icarebb.com/apidoc/#api-sg-VODFile.flv
    ayRecordPlay(row) {
      const url = this.proxyHost + URLS.ayVideoRecordPlayUrl
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const params = {
        id: this.code,
        start: row.recordTimeStart,
        end: row.recordTimeEnd,
        loc: recordFrom
      }
      axios.get(url, { params }).then((res) => {
        if (res && res.data.status === 200) {
          this.isPlaybackFlag = true
          this.videoSrc = res.data.result
        }
      })
    },
    myeyesRecordPlay(row) {
      const url = this.proxyHost + URLS.myeyesVideoCallbackUrl
      const dataSource = pick(this.iotVideoObj, ['code', 'streamType', 'mediaType'])
      const record = pick(row, ['recordTimeStart', 'recordTimeEnd', 'recordName'])
      const params = merge(dataSource, record)
      params.recordFrom = this.videoBackForm.recordLocation === 0 ? 'ss' : 'device'
      axios.post(url, params).then((res) => {
        if (res && res.status === 200) {
          // 回放状态
          this.isPlaybackFlag = true
          this.videoSrc = res.data.result
        }
      })
    },
    // # https://icvs.icarebb.com/apidoc/#api-sg-VODFile.flv
    icvsRecordPlay(row) {
      const url = this.proxyHost + URLS.getRecordUri
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const params = {
        ...row,
        recordFrom,
        code: this.iotVideoObj.code
      }
      axios.post(url, params).then((res) => {
        if (res && res.data.status === 200) {
          this.isPlaybackFlag = true
          this.videoSrc = res.data.result
        }
      })
    },
    //
    mjRecordPlay(row) {
      const url = this.proxyHost + URLS.mjGetUri
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const params = {
        rName: row.name,
        recordFrom,
        code: this.iotVideoObj.code
      }
      axios.post(url, params).then((res) => {
        if (res && res.data.status === 200) {
          const configObj = JSON.parse(res.data.result)
          const data = JSON.stringify({
            ...configObj,
            req: newGUID(),
            name: 'playback',
            cmd: 'create',
            image: 3 // 0-RGB 1-YUV 2-bmp 3-JPEG
          })
          this.$refs.videoPreview.restartWebSocket('ws://127.0.0.1:23350', data)
        }
      })
    },
    cancelPtzCommand(command, stopCommand) {
      // 如果外部代理云台方法存在
      if (this.proxyFunction && this.proxyFunction.cancelPtzCommand) {
        this.proxyFunction.cancelPtzCommand(command, stopCommand)
        return
      }
      // 明景云台
      if (this.iotVideoObj.source == SOURCE_ENUM.minking) {
        const url = this.proxyHost + URLS.yunTaiCtr
        const data = {
          videoCode: this.code,
          action: 0,
          command: 'right',
          speed: 40,
          step: 1,
          preset: 1,
          transParams: {
            command: MJMapCommand(command),
            param1: 0,
            param2: 5,
            param3: 0,
            param4: 0
          }
        }
        axios
          .post(url, data)
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // AY GB接口分离
      if (this.iotVideoObj.source == SOURCE_ENUM.ay) {
        const data = {
          command: stopCommand
        }
        axios
          .post(this.proxyHost + URLS.ayYunTaiCtlUrl + this.vlcOptions.channerId, data)
          .then((res) => {})
          .catch((err) => {
            console.log(err)
          })
        return
      }
      // 云台控制
      if (SUPPORT_PTZS.indexOf(this.iotVideoObj.source) > -1) {
        const url = this.proxyHost + URLS.yunTaiCtr
        const data = {
          videoCode: this.code,
          action: 1,
          command: stopCommand
        }
        axios.post(url, data).then((res) => {
          console.log(res)
        })
        return
      }
    },
    // 云台控制
    startPtzCommand(command) {
      console.log(command);
      // 如果外部代理云台方法存在
      if (this.proxyFunction && this.proxyFunction.startPtzCommand) {
        this.proxyFunction.startPtzCommand(command)
        return
      }

      // 明景布控球接口分离
      if (this.iotVideoObj.source == SOURCE_ENUM.minking) {
        const url = this.proxyHost + URLS.yunTaiCtr
        const data = {
          videoCode: this.code,
          action: 0,
          command: 'right',
          speed: 40,
          step: 1,
          preset: 1,
          transParams: {
            command: MJMapCommand(command),
            param1: 1,
            param2: 5,
            param3: 0,
            param4: 0
          }
        }
        axios
          .post(url, data)
          .then((res) => {})
          .catch((err) => {
            console.log(err)
          })
        return
      }
      // AY GB接口分离
      if (this.iotVideoObj.source == SOURCE_ENUM.ay) {
        const data = {
          command:command,
          speed:this.ptzOption.speed
        }
        axios
          .post(this.proxyHost + URLS.ayYunTaiCtlUrl + this.vlcOptions.channerId, data)
          .then((res) => {})
          .catch((err) => {
            console.log(err)
          })
        return
      }
      // 云台控制
      if (SUPPORT_PTZS.indexOf(this.iotVideoObj.source) > -1) {
        const url = this.proxyHost + URLS.yunTaiCtr
        const data = {
          videoCode: this.code,
          action: 0,
          command: command,
          ...this.ptzOption
        }
        axios.post(url, data).then((res) => {
          // setTimeout(() => {
          //   this.cancelPtzCommand("stop");
          // }, 10000)
        })
      }
    },
    // dispose卸载
    dispose() {
      this.$refs.videoPreview.dispose()
    },
       // 大华预览
    // realByUrl(val,num) {
    //   this.$refs.videoPreview.realByUrl(val,num)
    // },
    DHiccPlay(val,num) {
      this.DHvideoType = this.DHvideoType==='video1' ? 'video2' :'video1';
      document.querySelector('#autoPlayBtn').innerText = this.DHvideoType==='video1' ? '回看' : '预览';
      // document.querySelector('#autoPlayBtn').innerHTML = 'video1' ? '回看' : '预览';
      // console.error('click',this.videoSrc);
      //   this.$refs.videoPreview.realByUrl(
      //     {
      //       channelId: '', //''
      //       path: this.videoSrc,
      //       redirect: false //false
      //     },
      //     0
      //   )
    },
    createSuccess(){
      // console.error('videoPreviewExpand   createSuccess');
      // this.DHiccPlay()
    },
    DHiccClose(){
      this.$refs.videoPreview.dispose()
    },
    recordBlob(val){
      if(val){
        this.$emit('recordBlob',val)
      }
    }
  }
}
</script>

<style lang="scss">
// over element
.video-preview-expand {
  .el-input__inner {
    border-radius: 0px;
    border: 1px solid #dbdbdb;
  }
  .el-radio + .el-radio {
    margin-left: 0px;
  }
}
.vp-date-popper {
  z-index: 9999 !important;
}
</style>

<style lang="scss">
.video-preview-expand {
  width: 100%;
  height: 100%;
  .vp-block {
    width: 100%;
  }
  .vp-button {
    border-width: 1px solid #dbdbdb;
    border-radius: 0px;
  }
  .vp-button + .vp-button {
    margin-left: 0.2em;
  }
  .vp-table {
    .vp-table-header {
      font-size: 12px;
    }
  }
  &-container {
    width: 100%;
    height: 100%;
    &-voice {
      text-align: center;
      width: 230px;
      padding-top: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    &-ptz {
      width: 230px;
      flex: 0 0 230px;
      height: 100%;
      .title {
        font-size: 16px;
        margin-block-start: 4px;
        margin-block-end: 4px;
      }
    }
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      overflow: hidden;
      background: #f1f1f1;
      .vptb-left {
        display: flex;
        align-items: flex-start;
      }
      .increase-or-decrease {
        display: inline-block;
        height: 40px;
        &-item {
          box-sizing: border-box;
          width: 34px;
          height: 34px;
          border: 1px solid #d9d9d9;
          padding: 6px;
          margin: 3px;
          border-radius: 2px;
        }
      }
      .vptb-block {
        display: flex;
        align-items: center;
        .title {
        }
      }
      .vptc-direction {
        width: 120px;
        &-container {
          display: flex;
          flex-wrap: wrap;
          align-content: baseline;
          width: 100%;
          height: 120px;
          &-item {
            box-sizing: border-box;
            width: 34px;
            height: 34px;
            border: 1px solid #d9d9d9;
            padding: 6px;
            margin: 3px;
            border-radius: 2px;
            img {
              width: 18px;
              height: 18px;
            }
          }
        }
      }
      .vptc-focal {
        width: 80px;
        flex-direction: column;
      }
      .vptc-aperture {
        width: 100px;
      }
      .vptc-reset {
        width: 160px;
        text-align: right;
        .range-input {
          width: 100%;
        }
        .speed-value {
          border: 2px solid #333;
          padding: 0 4px;
        }
      }
    }
    &-videoback {
      width: 230px;
      flex: 0 0 230px;
      height: 100%;
      .title {
        font-size: 16px;
        margin-block-start: 4px;
        margin-block-end: 4px;
      }
    }
  }
  &-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    .tbl {
      height: 30px;
      span {
        line-height: 30px;
      }
    }
    .tbc {
      span {
        line-height: 30px;
        font-size: 12px;
      }
    }
    .tbr {
      height: 30px;
      display: flex;
      align-items: center;
      img + img {
        margin-left: 10px;
      }
    }
  }
}
		.media-play-urls {
			height: 140px;
			.mpu-title{
					border-bottom: 1px solid #f1f1f6;
			}
			&-list {
				&-item {
					height: 30px;
					line-height: 30px;
					display: flex;
					justify-content: space-between;
					border-bottom: 1px solid #f1f1f6;
					&.highlight {
						background: #c5c5c5;
					}
					.mpuli-left {
						width: calc(100% - 80px);
						display: flex;
						.mpuli-type {
							font-weight: 600;
							margin-right: 10px;
							display: inline-block;
							width: 40px;
						}	
						.mpuli-url {
							display: inline-block;
							width: calc(100% - 70px);
							word-break:keep-all;
							white-space:nowrap;
							overflow:hidden;
							text-overflow:ellipsis;
						}
					}
				}
			}
		}
</style>
